import { HttpContextToken, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { TenantFacade } from "@core/data/tenant/tenant-facade";

export const SKIP_TENANT_HEADER = new HttpContextToken<boolean>(() => false);

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
    const tenantFacade = inject(TenantFacade);
    const tenantId = tenantFacade.currentTenant()?.uuid;

    if (req.context.get(SKIP_TENANT_HEADER) || !tenantId) return next(req);


    const clonedRequest = req.clone({
        setHeaders: { 'X-Aida-Tenant': tenantId}
    });
    return next(clonedRequest);
}
